(function (app, ng) {

    function groupBy(_) {
        var fn = function (list, groupByFn) {
            return _.groupBy(list, groupByFn);
        };

        return _.memoize(fn, function (input) { return JSON.stringify(input) });
    }

    groupBy.$inject = ["_"];
    app.filter("groupBy", groupBy);

})(window.app, window.angular); //jshint ignore:line